var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "d-flex flex-row mb-2 align-items-center" }, [
      _c("div", { staticClass: "d-inline-block mr-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("tnt.batch")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-grow-1 d-inline-block mr-2" },
        [
          _c("vSelect", {
            attrs: {
              options: _vm.batchesForDropDown,
              label: "identifier",
              reduce: e => e.id,
              multiple: true
            },
            model: {
              value: _vm.selectedBatchIds,
              callback: function($$v) {
                _vm.selectedBatchIds = $$v
              },
              expression: "selectedBatchIds"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-inline-block mr-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("tnt.product")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-grow-1 d-inline-block mr-2" },
        [
          _c("vSelect", {
            attrs: {
              options: _vm.productsForDropDown,
              label: "name",
              reduce: e => e.id,
              multiple: true
            },
            model: {
              value: _vm.selectedProductIds,
              callback: function($$v) {
                _vm.selectedProductIds = $$v
              },
              expression: "selectedProductIds"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-inline-block mr-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("tnt.supplier")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-grow-1 d-inline-block mr-2" },
        [
          _c("vSelect", {
            attrs: {
              options: _vm.supplierForDropDown,
              label: "name",
              reduce: e => e.id,
              multiple: true
            },
            model: {
              value: _vm.selectedSupplierIds,
              callback: function($$v) {
                _vm.selectedSupplierIds = $$v
              },
              expression: "selectedSupplierIds"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-inline-block" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", on: { click: _vm.onFilter } },
          [_vm._v(_vm._s(_vm.$t("tnt.search")))]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-2" },
      [
        _c("VueGoodTable", {
          attrs: {
            columns: _vm.columns,
            "pagination-options": _vm.paginationOptions,
            "select-options": _vm.selectOptions,
            "search-options": _vm.searchOptions,
            mode: "remote",
            rows: _vm.itemsForTable,
            totalRows: _vm.vgtManager.results.totalRows,
            isLoading: _vm.vgtManager.isLoading
          },
          on: {
            "on-selected-rows-change": _vm.onVgtSelectionChanged,
            "on-page-change": function($event) {
              _vm.vgtManager.pageEvent.bind(_vm.vgtManager)($event)
            },
            "on-sort-change": function($event) {
              _vm.vgtManager.sortEvent.bind(_vm.vgtManager)($event)
            },
            "on-column-filter": function($event) {
              _vm.vgtManager.filterEvent.bind(_vm.vgtManager)($event)
            },
            "on-per-page-change": function($event) {
              _vm.vgtManager.perPageEvent.bind(_vm.vgtManager)($event)
            },
            "on-search": function($event) {
              _vm.vgtManager.searchEvent.bind(_vm.vgtManager)($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row mb-2 align-items-center" }, [
      _c("div", { staticClass: "d-inline-block mr-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("tnt.quantitySum") + ":") + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow-1 d-inline-block mr-2" }, [
        _vm._v("\n      " + _vm._s(_vm.quantitySum) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex flex-row mb-2 align-items-center" }, [
      _c("div", { staticClass: "d-inline-block mr-1" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("tnt.price.doSet")) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-grow-1 d-inline-block mr-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.price,
              expression: "price",
              modifiers: { number: true }
            }
          ],
          staticClass: "form-control",
          attrs: { type: "number" },
          domProps: { value: _vm.price },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.price = _vm._n($event.target.value)
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-inline-block" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_vm.canSetPrice },
            on: { click: _vm.onSetPrice }
          },
          [_vm._v(_vm._s(_vm.$t("tnt.price.doSet")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }